import { render } from "./SupplierUser.vue?vue&type=template&id=42fc4fde&ts=true"
import script from "./SupplierUser.ts?vue&type=script&lang=ts"
export * from "./SupplierUser.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__